// extracted by mini-css-extract-plugin
export default {"settingToggle":"SettingToggle_settingToggle__sdWBk","label":"SettingToggle_label__MsKCJ"};